import { QueryClient } from '@tanstack/react-query';

let appQueryClient: QueryClient | null = null;

export const setAppQueryClient = (client: QueryClient) => {
  appQueryClient = client;
};

export const getAppQueryClient = (): QueryClient | null => appQueryClient;
